/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudAccountDetails {
    getFixupPrototypeFunction() { return CloudAccountDetails.fixupPrototype; }

    static newInstance(model: Partial<CloudAccountDetails>): CloudAccountDetails {
        let obj = Object.assign(new CloudAccountDetails(), model);
        CloudAccountDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudAccountDetails>): CloudAccountDetails {
        if (!model) return null;
        return CloudAccountDetails.newInstance(<CloudAccountDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudAccountDetails) {
        if (!obj) return;

        models.CloudAccountDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudAccountDetails): boolean {
        Object.setPrototypeOf(obj, CloudAccountDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Cloud account id is unique can be obtained from the list cloud
     */
    id: string;

}
